import { render, staticRenderFns } from "./corpTag.vue?vue&type=template&id=47146fcd&scoped=true&"
import script from "./corpTag.vue?vue&type=script&lang=js&"
export * from "./corpTag.vue?vue&type=script&lang=js&"
import style0 from "./corpTag.vue?vue&type=style&index=0&id=47146fcd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47146fcd",
  null
  
)

export default component.exports